import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ArrayField, ArrayInput, Create, Datagrid, Edit, EditButton, FormTab, List, SelectInput, Show, ShowActions, SimpleFormIterator, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import EmailTemplateReferenceField from 'utils/GeneratedRaReference/EmailTemplateReferenceField';
import EmailTemplateReferenceInput from 'utils/GeneratedRaReference/EmailTemplateReferenceInput';
import UserReferenceField from 'utils/GeneratedRaReference/UserReferenceField';
import UserReferenceInput from 'utils/GeneratedRaReference/UserReferenceInput';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import HtmlField from 'utils/react-admin/fields/HtmlField';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import { GrapesjsInput, GrapesjsInputButton } from 'utils/react-admin/inputs/GrapesjsInput';
import { Permissions } from '../../ra-php-crud-api-auth';

export const CHOICES_EMAIL_LOG_STATUS = [
  { id: 'prepared', name: 'prepared', },
  { id: 'sending', name: 'sending', },
  { id: 'sent', name: 'sent', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <UserReferenceInput source="user_id" fullWidth />,
  <EmailTemplateReferenceInput source="email_template_id" fullWidth />,
  <TextInput source="to_name" fullWidth />,
  <TextInput source="to_email" fullWidth />,
  <TextInput source="subject" fullWidth />,
  <TextField source="content_html" fullWidth />,
  <SelectInput source="status" fullWidth choices={CHOICES_EMAIL_LOG_STATUS} />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateUserId: any[] = [];
const validateEmailTemplateId: any[] = [];
const validateToName: any[] = [];
const validateToEmail: any[] = [];
// const validateCcEmailArray: any[] = [];
// const validateBccEmailArray: any[] = [];
const validateSubject: any[] = [];
// const validateContentHtml: any[] = [];
const validateStatus: any[] = [];

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit" primaryText={(record: any) => record.id}></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <UserReferenceField source="user_id" fullWidth />
            <EmailTemplateReferenceField source="email_template_id" fullWidth />
            <TextField source="to_name" fullWidth />
            {/* <ArrayField source="cc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField>
            <ArrayField source="bcc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField> */}
            {/* <HtmlField source="content_html" fullWidth showButton /> */}
            <TextField source="status" fullWidth />
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <UserReferenceField source="user_id" fullWidth />
        <EmailTemplateReferenceField source="email_template_id" fullWidth />
        <TextField source="to_name" fullWidth />
        <TextField source="to_email" fullWidth />
        {/* <ArrayField source="cc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField>
        <ArrayField source="bcc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField> */}
        <TextField source="subject" fullWidth />
        <HtmlField source="content_html" fullWidth />
        <TextField source="status" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean }) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={4}><UserReferenceInput source="user_id" fullWidth validate={validateUserId} /></Grid>
          <Grid item xs={4}><EmailTemplateReferenceInput source="email_template_id" fullWidth validate={validateEmailTemplateId} /></Grid>
          <Grid item xs={4}><SelectInput source="status" fullWidth choices={CHOICES_EMAIL_LOG_STATUS} validate={validateStatus} /></Grid>
          <Grid item xs={6}><TextInput source="to_name" fullWidth validate={validateToName} /></Grid>
          <Grid item xs={6}><TextInput source="to_email" fullWidth validate={validateToEmail} /></Grid>
        </GridWrapper>
        {/* <ArrayInput source="cc_email_array"><SimpleFormIterator><TextInput source="text" /></SimpleFormIterator></ArrayInput>
        <ArrayInput source="bcc_email_array"><SimpleFormIterator><TextInput source="text" /></SimpleFormIterator></ArrayInput> */}
        <TextInput source="subject" fullWidth validate={validateSubject} />
        <HtmlField source="content_html" />
        {/* <GrapesjsInputButton source="content_html"><GrapesjsInput id="grapesjs-input-content_html" plugins={["gjs-preset-webpage",]} source="content_html" /></GrapesjsInputButton> */}

      </FormTab>

    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: ForwardToInboxIcon,
}

export default Resource;
